import { RdcConsignmentsApiService } from 'core/api';
import { IRdcConsignmentDao } from 'core/api/types/rdc.interface';
import { useEffect, useState } from 'react';
import SkeletonElement from 'shared/components/layout/skeleton-element';

interface IRdcOverviewSignatures {
  consignment: IRdcConsignmentDao;
}

const RdcOverviewSignatures = ({ consignment }: IRdcOverviewSignatures) => {
  const [image, setImage] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const prepare = async () => {
      try {
        const url = await RdcConsignmentsApiService.getSignatureUrl(consignment.uid);
        setImage(url);
      } finally {
        setLoading(false);
      }
    };
    if (consignment.signatureCaptured) {
      prepare();
    } else {
      setLoading(false);
    }
  }, [consignment.signatureCaptured, consignment.uid]);

  return (
    <div className='bg-white rounded-md shadow-md'>
      <div className='flex justify-between items-center p-4 border-b'>
        <p className='headline-06'>Signature</p>
      </div>
      <div className='p-4'>
        {loading && <SkeletonElement width='340px' height='340px' />}
        {!loading && !consignment.signatureCaptured && (
          <p className='text-stone-300'>No signature was captured for this consignment</p>
        )}
        {!loading && consignment.signatureCaptured && (
          <img className='max-h-[500px]' src={image} alt='Recipient signature' />
        )}
      </div>
    </div>
  );
};

export default RdcOverviewSignatures;
